module.exports = __webpack_public_path__ + "img/22.14b7365d.jpg";